module.exports = __webpack_public_path__ + "img/th_Type_2.3.bd558f3e.jpg";